import { BOT_NAME } from './Bot';
import { SUPPORT_EMAIL } from './Developer';
import { MAX_DAYS_THRESHOLD_FOR_USAGE_CHART } from './overview';
import { MAX_TIME_FOR_EDITING_OR_DELETING_REPORT_MESSAGE } from './reportMessage';

export const CONTACT_FOR_SUPPORT = `If you need further assistance or have any questions, feel free to contact our support team at ${SUPPORT_EMAIL}.`;

export const UNHANDLED_ERROR = `Something went wrong`;

export const UNAUTHORIZED = `You are not authorized to perform this action.`;

export const OAUTH_SCOPES_NOT_OBTAINED =
  'Required scopes are not obtained. User consent is required.';

export const TOO_MANY_REQUEST_FOR_MEMORY_CREATION_OR_UPDATE = `You already have memories which is in progress. Please wait for the completion of the inprogress memory.`;

export const SNAKE_CASE_VALIDATION_ERROR = `Use snake_case with lowercase letters, numbers, and underscores only, for example: daily_tech_standup.`;

export const GROUP_NAME_ALREADY_TAKEN_ERROR = `The group name is already taken. Please choose a different name and try again.`;

export const INVALID_ORGANIZATION_ID_ERROR = 'Invalid organization ID.';

export const INVALID_USER_ID_ERROR = 'Invalid user ID.';

export const CSV_FILE_REQUIRED_ERROR = 'CSV file is required.';

export const ORGANIZATION_NAME_MISMATCH_ERROR =
  'Organization name does not match.';

export const REPORT_MESSAGE_EDIT_MAX_TIME_LIMIT_ERROR = `I'm sorry, you can only edit message within ${MAX_TIME_FOR_EDITING_OR_DELETING_REPORT_MESSAGE} minutes of creation.`;

export const ORGANIZATION_ID_NOT_FOUND_ERROR = `Organization not found.`;

export const ERROR_WHILE_SECURITY_INTERACTION = `Something went wrong while updating security interaction.`;

export const ERROR_FETCHING_ORGANIZATION_SECURITY_DATA = `Something went wrong while getting security data.`;

export const USER_DETAILS_NOT_FOUND_ERROR = `User details not found.`;

export const MEMORY_NOT_FOUND_BY_ID =
  'Something went wrong while trying to get your specific memory to edit.';

export const NOT_FOUND_BY_ID =
  'Something went wrong while trying to get the item to edit.';

export const DUPLICATE_TASK_ERROR = 'Task already exists.';

export const NOT_AUTHORIZED_MESSAGE = `You are not authorized to make changes here. You need to be an admin. Please contact your ${BOT_NAME} system admin to upgrade your account to an admin too or email ${SUPPORT_EMAIL} for support. If DNS verification is pending, please complete this to make yourself an admin automatically.`;

export const NOT_AUTHORIZED_TOAST_MESSAGE = 'You need admin access.';

export const AUTO_RESYNC_FREQUENCY_REQUIRED =
  'Please select the auto resync frequency.';

export const MEMORY_BATCH_AUTO_RESYNC_LIMIT_REACHED =
  'I am sorry, but you have enabled automatic resync on too many memory batches. Please disable it on older batches or upgrade your plan.';

export const GOOGLE_CHAT_SPACE_ID_REQUIRED_ERROR =
  'Space ID is required to create Google Chat space memory.';

export const REMINDER_PAST_DATE_MESSAGE =
  'Reminder date cannot be set for the past.';

export const REPORT_MESSAGE_NOT_FOUND_BY_ID =
  'Something went wrong while trying to get your specific report message to edit.';

export const MAX_DAYS_THRESHOLD_FOR_USAGE_CHART_MESSAGE = `The selected start date is older than ${MAX_DAYS_THRESHOLD_FOR_USAGE_CHART} days. Please email ${SUPPORT_EMAIL} to request old data.`;

export const DNS_INCOMPLETE_MESSAGE = `No one in your organization has verified their domain authority. You'll need to complete DNS verification to prove ownership/authority. This will automatically make you the DOMAIN_OWNER of your organization in the ${BOT_NAME} system. Please reach out to ${SUPPORT_EMAIL} for assistance/questions.`;

export const INVALID_ENV_FOR_FASTAPI_MODULE =
  'Fastapi Proxy Module is only available in UAT environment.';

export const INVALID_USE_CASE = `Invalid use case. ${CONTACT_FOR_SUPPORT}`;

export const SELF_ROLE_CHANGE_NOT_ALLOWED = `I am sorry, but you cannot modify your own role. Please ask another admin to update your access. ${CONTACT_FOR_SUPPORT}`;

export const INSUFFICIENT_PERMISSION_ORG_ONBOARDING =
  'You do not have permission to create a new organization. Please contact your admin.';
